import { ApiResponse } from "apisauce";
import { aiNetwork } from "./network";
import { AiDailyUsage, SyllabusImport } from "../types/aiTypes";

export interface AiApi {
  getSyllabusImports: (limit?: number, cursor?: string) => Promise<ApiResponse<{ items: SyllabusImport[], cursor?: string }>>;
  getAiUsage: (limit?: number, cursor?: string) => Promise<ApiResponse<{ items: AiDailyUsage[], cursor?: string }>>;
  getSyllabusFileDownloadUrl: (fileName: string, userId: string, type: 'raw' | 'parsed') => Promise<ApiResponse<{ url: string }>>;
}

const getSyllabusImports = (limit: number = 5, cursor?: string) => aiNetwork.get<{ items: SyllabusImport[], cursor?: string }>(`/admin/syllabus-imports?limit=${limit}${cursor ? `&cursor=${cursor}` : ''}`);

const getAiUsage = (limit: number = 5, cursor?: string) => aiNetwork.get<{ items: AiDailyUsage[], cursor?: string }>(`/admin/ai-usage?limit=${limit}${cursor ? `&cursor=${cursor}` : ''}`);

const getSyllabusFileDownloadUrl = (fileName: string, userId: string, type: 'raw' | 'parsed') => {
  const params = new URLSearchParams({ fileName, userId, type });
  return aiNetwork.get<{ url: string }>(`/admin/syllabus-file-download-url?${params.toString()}`);
}

export const aiApi: AiApi = {
  getSyllabusImports,
  getAiUsage,
  getSyllabusFileDownloadUrl
};